import axios, { CancelTokenSource } from 'axios';
import { getWhenAuthorized, postWhenAuthorized, deleteWhenAuthorized } from './api';

export interface IDocumentMessageState {
    subject: string;
    attachments: File[];
    sendToGroup: boolean;
    message: string;
}

export const initialDocumentMessageState: IDocumentMessageState = {
    subject: '',
    attachments: [],
    sendToGroup: false,
    message: ''
}

export const getGroupMessages = async (groupId: string, cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) => await getWhenAuthorized(() => `/api/group/${groupId}/messages`, cancelTokenSource);

export const getMessageThread = async (groupId: string, threadId: string, cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) => await getWhenAuthorized(() => `/api/group/${groupId}/messages/${threadId}`, cancelTokenSource);

export const addFavoriteAttachment = async (attachmentId: string, cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) => await postWhenAuthorized(() => `/api/group/addfavoriteattachment`, { attachmentId }, cancelTokenSource);

export const removeFavoriteAttachment = async (attachmentId: string, cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) => await postWhenAuthorized(() => `/api/group/removefavoriteattachment`, { attachmentId }, cancelTokenSource);

export const addDocumentsMessage = async (groupId: string, documentsMessageRequest: IDocumentMessageState, cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) => {
    try {
        const formData = new FormData();

        formData.append('subject', documentsMessageRequest.subject);

        for (const file of documentsMessageRequest.attachments) {
            formData.append('attachments', file);
        }

        formData.append('sendToGroup', documentsMessageRequest.sendToGroup.toString());

        if (documentsMessageRequest.sendToGroup) {
            formData.append('message', documentsMessageRequest.message);
        }

        return await postWhenAuthorized(() => `/api/group/${groupId}/message`, formData, cancelTokenSource);
    } catch (error) {
        if (!axios.isCancel(error)) {
            throw error;
        }
    }

    return undefined;
}

export const deleteMessage = async (groupId: string, messageId: string, cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) => await deleteWhenAuthorized(() => `/api/group/${groupId}/message/${messageId}`, cancelTokenSource);